module.exports = __webpack_public_path__ + "img/i_my_c_docu.86cd8eb2.svg";